import { render, staticRenderFns } from "./OverviewSegmentedControl.vue?vue&type=template&id=fdec793e"
import script from "./OverviewSegmentedControl.vue?vue&type=script&lang=js"
export * from "./OverviewSegmentedControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports